// Strict: require API base URL from .env
const API_BASE_URL = (import.meta.env.VITE_API_BASE_URL as string | undefined) ?? '';
if (!API_BASE_URL) {
  throw new Error('Missing VITE_API_BASE_URL (.env not configured)');
}

function joinUrl(base: string, path: string): string {
  if (!base) return path;
  const b = base.replace(/\/?$/u, '');
  const p = path.startsWith('/') ? path : `/${path}`;
  return `${b}${p}`;
}

/** Fire-and-forget POST JSON, optimized to not block navigation. */
export function apiPost(path: string, data?: unknown, init?: RequestInit): void {
  const url = joinUrl(API_BASE_URL, path);
  try {
    // Keepalive to allow the request to complete during page unload
    fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...(init?.headers || {}) },
      body: data ? JSON.stringify(data) : '{}',
      keepalive: true,
      ...init,
    }).catch(() => { /* ignore */ });
  } catch {
    // ignore network errors for analytics
  }
}

export { API_BASE_URL };
